export const dashboard = {
  title: 'Vezérlőpult',
  subtitle: 'Üzleti áttekintés és statisztikák',
  welcome: {
    morning: 'Jó reggelt, ',
    afternoon: 'Jó napot, ',
    evening: 'Jó estét, ',
    message: 'Üdvözöljük a rendszerben!',
    motivationalMessages: [
      'Készen állsz egy sikeres napra!',
      'Ma nagyszerű dolgokat fogsz véghez vinni!',
      'A mai nap tele van lehetőségekkel!',
      'Együtt építjük a jövőt!',
      'A siker titka a kezdeményezés!',
      'Minden nagy dolog kis lépésekkel kezdődik!',
      'A lehetetlen is lehetségessé válik, ha hiszel benne!',
      'A mai nap a Te napod!',
      'Tegyük együtt még jobbá a világot!',
      'A kiválóság nem cél, hanem életforma!'
    ]
  },
  stats: {
    totalQuotations: 'Összes árajánlat',
    activeCustomers: 'Aktív ügyfelek',
    successRate: 'Sikerességi ráta',
    totalRevenue: 'Teljes bevétel',
    totalContracts: 'Összes szerződés'
  },
  revenueOverview: 'Bevétel áttekintés',
  recentQuotations: 'Legutóbbi árajánlatok',
  vsLastMonth: 'vs előző hónap',
  expiringContracts: {
    title: 'Hamarosan lejáró szerződések',
    noContracts: 'Nincs hamarosan lejáró szerződés',
    daysLeft: '{{count}} nap van hátra',
    days: '{{count}} nap van hátra',
    type: {
      contract: 'Szerződés',
      quotation: 'Árajánlat'
    }
  }
}